document.addEventListener("DOMContentLoaded", () => {
  handleMCInfoShowcase();
});

function handleMCInfoShowcase() {
  const config = {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: true,
    navigation: {
      nextEl: ".mc-info-showcase__media-swiper-navigation-next",
      prevEl: ".mc-info-showcase__media-swiper-navigation-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  };

  const mcInfoShowCaseSwiper = new Swiper(
    ".mc-info-showcase__media-swiper",
    config
  );
}
